<script setup lang="ts">

import { useAppConfiguration } from "@domain/AppConfiguration";

interface IDealerLocationProps
{
    type?: 'dealership' | 'service'
}

const props = withDefaults( defineProps<IDealerLocationProps>(), { type: 'dealership' } );
const app = useAppConfiguration();
const location = props.type == 'dealership'
    ? app.dealerLocation
    : app.serviceLocation;

</script>
<template>

    <div class="w-full flex flex-col items-center 
                px-4 py-3 lg:px-6 lg:py-4 3xl:px-8 3xl:py-6
                text-base lg:text-lg 3xl:text-xl leading-tight
                shadow rounded-lg tracking-wider
                ring-4 dark:ring-gray-800/50 
                border border-gray-700
                bg-gradient-to-b dark:from-gray-850 dark:to-gray-800">

        <div class="text-base lg:text-lg 3xl:text-xl mb-1 3xl:mb-3 uppercase flex justify-center w-full text-center">
            {{ location.name }}
        </div>
        <div class="opacity-60">{{ location.addressLine1 }}</div>
        <div v-if="location.addressLine2" class="opacity-60">{{ location.addressLine2 }}</div>
        <div class="opacity-60">{{ location.city }}</div>
        <div class="opacity-60 mb-1">{{ location.state }} {{ location.postcode }}</div>

        <!-- ACTIONS -->
        <div class="w-full grid grid-cols-2 gap-2 md:gap-3 3xl:gap-4 mt-4">

            <JupiterButton variant="tonal"
                           type="tel" 
                           :to="location.phone"
                           class="flex-1 !h-10 3xl:!h-12">
                <span class="flex items-center gap-1 3xl:gap-3">
                    <Icon name="phone" class="text-2xl" />
                    <span class="3xl:text-base">
                        Call
                    </span>
                </span>
            </JupiterButton>

            <JupiterButton variant="tonal"
                           type="email" 
                           :to="location.email"
                           class="flex-1 !h-10 3xl:!h-12">
                <span class="flex items-center gap-1 3xl:gap-3">
                    <Icon name="email" class="text-2xl" />
                    <span class="3xl:text-base">
                        Email
                    </span>
                </span>
            </JupiterButton>

            <JupiterButton v-if="type == 'service' && app.hasServiceBookingUrl"
                           variant="tonal"
                           type="url" 
                           :to="app.getServiceBookingUrl()"
                           class="col-span-2 !h-10 3xl:!h-12">
                <span class="flex items-center gap-1 3xl:gap-3">
                    <Icon name="calendar" class="text-2xl" />
                    <span class="3xl:text-base">
                        Book a Service
                    </span>
                </span>
            </JupiterButton>
            
            <JupiterButton v-else-if="type == 'dealership' && app.dealerLocation.linkUrl"
                           variant="tonal"
                           type="url"
                           :to="app.dealerLocation.linkUrl"
                           class="col-span-2 !h-10 3xl:!h-12">
                <span class="flex items-center gap-1 3xl:gap-3">
                    <Icon name="home" class="text-2xl" />
                    <span class="3xl:text-base">
                        Visit Website
                    </span>
                </span>
            </JupiterButton>

        </div>
    </div>

</template>